/* Menu image deferral: promo images inside the desktop mega menu and the
   mobile drawer are invisible until the menu opens, but hidden <img> elements
   bypass native lazy-loading and download upfront, competing with the LCP
   hero. They are rendered inside <template data-menu-image> and injected on
   the first user interaction (long before any menu can open), with a
   post-load timer as a safety net. */
(function () {
  var hydrated = false;

  function hydrate() {
    if (hydrated) return;
    hydrated = true;

    document.querySelectorAll('template[data-menu-image]').forEach(function (tpl) {
      tpl.replaceWith(tpl.content.cloneNode(true));
    });

    ['pointermove', 'touchstart', 'keydown', 'scroll'].forEach(function (evt) {
      document.removeEventListener(evt, hydrate);
    });
  }

  ['pointermove', 'touchstart', 'keydown', 'scroll'].forEach(function (evt) {
    document.addEventListener(evt, hydrate, { passive: true });
  });

  var SAFETY_DELAY_MS = 3000;
  window.addEventListener('load', function () {
    setTimeout(hydrate, SAFETY_DELAY_MS);
  });
})();
